		//Product slider
        jQuery(".product-row").slick({
            dots: false, 
            autoplay: true, 
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 1025,
                     settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        arrows: false,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 792,
                     settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 576,
                     settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 375,
                     settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
        jQuery(window).scroll(function(){
              if (jQuery(this).scrollTop() > 40) {
                  jQuery('body').addClass('fixed-menu');
                  jQuery('.top_bar').addClass('fixed');
              } else {
                  jQuery('body').removeClass('fixed-menu');
                  jQuery('.top_bar').removeClass('fixed');
              }
        });

        $( document ).ready(function() {
				$('.playlist-slider>.row').slick({
					slidesToShow: 5,
					slidesToScroll: 1,
					autoplay: true,
					arrows:false,
					dots:false,
					autoplaySpeed: 4000,
					responsive: [
						{
						breakpoint: 1199,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 1,
							}
						},
						{
						breakpoint: 991,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1,
							}
						},
						{
						breakpoint: 767,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							}
						},
						{
						breakpoint: 440,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
							}
						}
					]
				});
			});